/** Shared board geometry and connections. See docs/RULES.md for the rule table. */
export interface BoardNode { id: string; label: string; x: number; y: number }

const outer: BoardNode[] = Array.from({ length: 20 }, (_, i) => {
  const n = i + 1;
  const [x, y] = n <= 5 ? [520, 520 - n * 88]
    : n <= 10 ? [520 - (n - 5) * 88, 80]
    : n <= 15 ? [80, 80 + (n - 10) * 88]
    : [80 + (n - 15) * 88, 520];
  return { id: `O${n}`, label: n === 20 ? '출발' : n === 5 || n === 10 ? '갈림' : n === 15 ? '모서리' : '', x, y };
});

export const BOARD_NODES: BoardNode[] = [
  ...outer,
  { id: 'X1', label: '', x: 446.667, y: 153.333 },
  { id: 'X2', label: '', x: 373.333, y: 226.667 },
  { id: 'C', label: '중앙', x: 300, y: 300 },
  { id: 'X4', label: '', x: 226.667, y: 373.333 },
  { id: 'X5', label: '', x: 153.333, y: 446.667 },
  { id: 'Y1', label: '', x: 153.333, y: 153.333 },
  { id: 'Y2', label: '', x: 226.667, y: 226.667 },
  { id: 'Y4', label: '', x: 373.333, y: 373.333 },
  { id: 'Y5', label: '', x: 446.667, y: 446.667 },
  { id: 'HOME', label: '대기', x: 576, y: 565 },
  { id: 'FINISH', label: '완주', x: 575, y: 505 },
];

export const OUTER_ROUTE = Array.from({ length: 20 }, (_, i) => `O${i + 1}`);
export const X_ROUTE = ['O5', 'X1', 'X2', 'C', 'X4', 'X5', 'O15'];
export const Y_ROUTE = ['O10', 'Y1', 'Y2', 'C', 'Y4', 'Y5', 'O20'];
const pairs = (nodes: string[]): [string, string][] => nodes.slice(1).map((id, i) => [nodes[i]!, id]);
export const BOARD_EDGES: [string, string][] = [
  ...pairs(['O20', ...OUTER_ROUTE]), ...pairs(X_ROUTE), ...pairs(Y_ROUTE),
];

/** Route choices are made only at the first step of a move. */
export function forwardPaths(position: string, steps: number): { path: string[]; route: string }[] {
  if (position === 'FINISH' || steps <= 0) return [];
  const routes = position === 'O5' ? ['outer', 'X']
    : position === 'O10' ? ['outer', 'Y']
    : position === 'C' ? ['X', 'Y']
    : [position.startsWith('X') ? 'X' : position.startsWith('Y') ? 'Y' : 'outer'];
  return routes.map(route => {
    const path = [position];
    let current = position;
    let line = route;
    for (let i = 0; i < steps && current !== 'FINISH'; i++) {
      if (current === 'HOME') current = 'O1';
      else if (line !== 'outer') {
        const diagonal = line === 'X' ? X_ROUTE : Y_ROUTE;
        const index = diagonal.indexOf(current);
        if (index < 0) throw new Error('알 수 없는 대각선 위치입니다.');
        if (index === diagonal.length - 1) {
          line = 'outer';
          current = current === 'O20' ? 'FINISH' : `O${Number(current.slice(1)) + 1}`;
        } else current = diagonal[index + 1]!;
      } else {
        current = current === 'O20' ? 'FINISH' : `O${Number(current.slice(1)) + 1}`;
      }
      path.push(current);
    }
    return { path, route };
  });
}
